// Modül 9 - Birebir Mülakat Simülasyonu - İnteraktif İçerikler

const cabinCrewContentsM9Interactive = {
  // ==================== ÜNİTE 1: MOTİVASYON SORUSU ====================
  'CM-M9-U1-L1': {
    lesson_id: 'CM-M9-U1-L1',
    title: 'Profesyonel Motivasyon',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '❓ "Neden Kabin Memuru?" - Profesyonel Cevap',
      intro: 'Bu soru HER birebir mülakatta sorulur!',
      categories: [
        { icon: '❌', title: 'YANLIŞ', examples: '"Gezmek istiyorum"', desc: 'Yüzeysel, turist!' },
        { icon: '❌', title: 'YANLIŞ', examples: '"İyi maaş"', desc: 'Motivasyonsuz' },
        { icon: '✅', title: 'DOĞRU', examples: '"Hizmet ve güvenlik tutkusu"', desc: 'Mesleği anlıyor' },
        { icon: '✅', title: 'DOĞRU', examples: '"Farklı insanlara yardım"', desc: 'Empati gösteriyor' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi motivasyon cevabı?',
        options: [
          { text: 'Dünyayı gezmek hayalım', isCorrect: false, feedback: '❌ Turist cevabı!' },
          { text: 'Hizmet tutkusu ve güvenlik sorumluluğu', isCorrect: true, feedback: '✅ Profesyonel!' },
          { text: 'Hostes üniforması çok güzel', isCorrect: false, feedback: '❌ Yüzeysel!' }
        ]
      }
    }
  },

  'CM-M9-U1-L2': {
    lesson_id: 'CM-M9-U1-L2',
    title: 'Yüzeysel Cevaplardan Kaçınma',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🚫 Yüzeysel Cevaplar = ELEME',
      intro: 'Şu cevaplar sizi eler:',
      facts: [
        { icon: '❌', title: 'Gezi', text: '"Dünyayı dolaşmak" = Turist' },
        { icon: '❌', title: 'Para', text: '"İyi maaş ve yan haklar" = Motivasyonsuz' },
        { icon: '❌', title: 'Üniforma', text: '"Hostes üniforması güzel" = Yüzeysel' },
        { icon: '❌', title: 'Prestij', text: '"Prestijli meslek" = Ego' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Hangi cevap ELEME sebebi?',
        options: [
          { text: 'Takım çalışmasını seviyorum', isCorrect: false, feedback: '❌ Bu iyi!' },
          { text: 'Bedava seyahat etmek istiyorum', isCorrect: true, feedback: '✅ ELEME! Turist cevabı!' },
          { text: 'Farklı kültürlerle iletişim', isCorrect: false, feedback: '❌ Bu iyi!' }
        ]
      }
    }
  },

  'CM-M9-U1-L3': {
    lesson_id: 'CM-M9-U1-L3',
    title: 'Simülasyon: Motivasyon',
    type: 'scenario',
    duration: 5,
    xp: 50,
    scenario: {
      question: '🎤 SİMÜLASYON: "Neden Kabin Memuru?"',
      context: 'HR yöneticisi soruyor: "Neden bu mesleği seçtiniz? Çok yol var, neden bu?"',
      options: [
        { id: 'A', text: '"Dünyayı gezmek ve farklı yerler görmek istiyorum"', isCorrect: false },
        { id: 'B', text: '"Hizmet tutkum var, dinamik ortamda takımla çalışmayı seviyorum"', isCorrect: true },
        { id: 'C', text: '"THY prestijli, ailem çok istiyor"', isCorrect: false },
        { id: 'D', text: '"Maaş ve sosyal haklar iyi"', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 PROFESYONEL! Hizmet + Takım + Dinamik = Mesleği anlıyor!',
        wrong: '❌ Gezi, para, prestij = Yüzeysel motivasyon = ELEME!'
      },
      explanation: 'Güçlü cevap: Hizmet tutkusu + Takım çalışması + Dinamik ortam + Kişisel özelliklerle eşleştirme'
    }
  },

  'CM-M9-U1-L4': {
    lesson_id: 'CM-M9-U1-L4',
    title: '🎮 Sırala: Motivasyon Cevabı',
    type: 'dragdrop',
    duration: 3,
    xp: 40,
    dragdrop: {
      instruction: 'Güçlü motivasyon cevabını sırala',
      items: [
        { text: '💗 Hizmet tutkusu', order: 1 },
        { text: '👥 Takım çalışması sevgisi', order: 2 },
        { text: '🌐 Farklı kültürlerle iletişim', order: 3 },
        { text: '⚡ Dinamik çalışma ortamı', order: 4 },
        { text: '📚 Sürekli gelişim fırsatı', order: 5 }
      ]
    }
  },

  // ==================== ÜNİTE 2: KENDİNİ TANITMA ====================
  'CM-M9-U2-L1': {
    lesson_id: 'CM-M9-U2-L1',
    title: 'Yapılandırılmış Cevap',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🎤 "Tell Me About Yourself" - Yapı',
      intro: '90 saniyede kendini nasıl tanıtırsın?',
      steps: [
        { level: 1, title: '👤 ŞİMDİ', desc: 'Mevcut durumun (iş/eğitim)' },
        { level: 2, title: '💼 GEÇMİŞ', desc: 'Alakalı deneyimler' },
        { level: 3, title: '🎯 GELECEK', desc: 'Neden bu pozisyon?' },
        { level: 4, title: '✨ ÖZEL', desc: 'Seni farklı kılan ne?' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Kendini tanıtırken ne ile BAŞLAMAMali?',
        options: [
          { text: 'Mevcut durumunla', isCorrect: false, feedback: '❌ Bu doğru başlangıç!' },
          { text: 'Çocukluk anılarınla', isCorrect: true, feedback: '✅ DOĞRU! Çok geriye gitme!' },
          { text: 'Profesyonel deneyiminle', isCorrect: false, feedback: '❌ Bu da iyi!' }
        ]
      }
    }
  },

  'CM-M9-U2-L2': {
    lesson_id: 'CM-M9-U2-L2',
    title: 'Güçlü Yönler',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '💪 Güçlü Yönlerini Vurgula',
      intro: 'İşle ilgili güçlü yönleri seç:',
      categories: [
        { icon: '✅', title: 'İLGİLİ', examples: 'Empati, stres yönetimi', desc: 'Kabin memurluğu için' },
        { icon: '✅', title: 'İLGİLİ', examples: 'Takım çalışması, iletişim', desc: 'Havacılık için' },
        { icon: '❌', title: 'İLGİSİZ', examples: 'İyi yemek yaparım', desc: 'Alakasız!' },
        { icon: '❌', title: 'İLGİSİZ', examples: 'Futbol oynarım', desc: 'Alakasız!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi güçlü yön örneği?',
        options: [
          { text: 'Bilgisayar kullanırım', isCorrect: false, feedback: '❌ Alakasız!' },
          { text: 'Baskı altında sakin kalırım', isCorrect: true, feedback: '✅ Kabin memurluğu için kritik!' },
          { text: 'Erken kalkarım', isCorrect: false, feedback: '❌ Yeterince güçlü değil!' }
        ]
      }
    }
  },

  'CM-M9-U2-L3': {
    lesson_id: 'CM-M9-U2-L3',
    title: 'Simülasyon: Tanıtım',
    type: 'scenario',
    duration: 5,
    xp: 50,
    scenario: {
      question: '🎤 SİMÜLASYON: "Kendinizi Tanıtın"',
      context: 'Değerlendirmeci: "Kendinizi kısaca tanıtır mısınız?"',
      options: [
        { id: 'A', text: 'Doğum yerim X, ilkokuldan başlayalım...', isCorrect: false },
        { id: 'B', text: 'Şu an Y sektöründe çalışıyorum, müşteri hizmetinde X yıl deneyimim var', isCorrect: true },
        { id: 'C', text: 'Adım X, Y yaşındayım', isCorrect: false },
        { id: 'D', text: 'Özgeçmişimde her şey yazıyor', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 PROFESYONEL! Şimdiki durum + Deneyim + Değer!',
        wrong: '❌ Çok geriye gitme veya geçiştirme!'
      },
      explanation: 'Güçlü tanıtım: Şimdi + Alakalı deneyim + Bu pozisyona uygunluk'
    }
  },

  'CM-M9-U2-L4': {
    lesson_id: 'CM-M9-U2-L4',
    title: '🎮 Doğru mu Yanlış mı?',
    type: 'truefalse',
    duration: 3,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Kendini tanıtırken çocukluktan başlamalısın.', isTrue: false, explanation: '❌ Çok geriye gitme, profesyonel başla!' },
        { statement: 'Güçlü yönler işle ilgili olmalı.', isTrue: true, explanation: '✅ Alakalı özellikler vurgula!' },
        { statement: '90 saniye ideal tanıtım süresi.', isTrue: true, explanation: '✅ Kısa ve özlü!' },
        { statement: '"Özgeçmişimde var" diyebilirsin.', isTrue: false, explanation: '❌ Geçiştirme, anlat!' },
        { statement: 'Hobilerinizi detaylı anlatın.', isTrue: false, explanation: '❌ Sadece alakalıysa kısaca!' }
      ]
    }
  },

  // ==================== ÜNİTE 3: STAR METODU ====================
  'CM-M9-U3-L1': {
    lesson_id: 'CM-M9-U3-L1',
    title: 'Situation-Task',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🎯 STAR: Situation + Task',
      intro: 'Davranışsal sorularda STAR formatı:',
      steps: [
        { level: 'S', title: 'SİTUATİON', desc: 'Durum ne? Bağlam ve ortam' },
        { level: 'T', title: 'TASK', desc: 'Görevin ne? Sorumluluğun' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'SİTUATİON bölümünde ne anlatılır?',
        options: [
          { text: 'Yaptıkların', isCorrect: false, feedback: '❌ Bu ACTION!' },
          { text: 'Bağlam ve ortam', isCorrect: true, feedback: '✅ Durum açıklaması!' },
          { text: 'Sonuçlar', isCorrect: false, feedback: '❌ Bu RESULT!' }
        ]
      }
    }
  },

  'CM-M9-U3-L2': {
    lesson_id: 'CM-M9-U3-L2',
    title: 'Action-Result',
    type: 'interactive',
    duration: 3,
    xp: 25,
    content: {
      title: '🎯 STAR: Action + Result',
      intro: 'STAR\'in ikinci yarısı:',
      steps: [
        { level: 'A', title: 'ACTİON', desc: 'Ne yaptın? Spesifik adımlar' },
        { level: 'R', title: 'RESULT', desc: 'Sonuç ne oldu? Ölçülebilir etki' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'RESULT kısmında ne olmalı?',
        options: [
          { text: 'Duyguların', isCorrect: false, feedback: '❌ Somut sonuç!' },
          { text: 'Ölçülebilir başarı veya öğrenilen ders', isCorrect: true, feedback: '✅ Somut etki!' },
          { text: 'Başkalarının tepkisi', isCorrect: false, feedback: '❌ Senin sonucun!' }
        ]
      }
    }
  },

  'CM-M9-U3-L3': {
    lesson_id: 'CM-M9-U3-L3',
    title: '📝 STAR Quiz',
    type: 'quiz',
    duration: 4,
    xp: 50,
    quiz: {
      questions: [
        { q: 'S = ?', options: ['Solution', 'Situation', 'Story', 'Success'], correct: 1 },
        { q: 'T = ?', options: ['Time', 'Task', 'Team', 'Try'], correct: 1 },
        { q: 'A = ?', options: ['Answer', 'Action', 'Always', 'All'], correct: 1 },
        { q: 'R = ?', options: ['Result', 'Ready', 'Run', 'Real'], correct: 0 },
        { q: 'En uzun kısım?', options: ['S', 'T', 'A', 'R'], correct: 2 }
      ]
    }
  },

  'CM-M9-U3-L4': {
    lesson_id: 'CM-M9-U3-L4',
    title: '⚡ STAR Zaman Yarışı',
    type: 'timerace',
    duration: 3,
    xp: 55,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'STAR\'da S?', options: ['Story', 'Situation', 'Success', 'Step'], correct: 1 },
        { q: 'Durum açıklaması nerede?', options: ['T', 'A', 'R', 'S'], correct: 3 },
        { q: 'Yaptıkların nerede?', options: ['S', 'T', 'A', 'R'], correct: 2 },
        { q: 'Sonuç nerede?', options: ['S', 'T', 'A', 'R'], correct: 3 },
        { q: 'Görev açıklaması?', options: ['S', 'T', 'A', 'R'], correct: 1 },
        { q: 'En kısa kısım?', options: ['S', 'T', 'A', 'R'], correct: 1 }
      ]
    }
  },

  'CM-M9-U3-L5': {
    lesson_id: 'CM-M9-U3-L5',
    title: '🎮 Boşluk Doldur',
    type: 'fillin',
    duration: 3,
    xp: 45,
    fillin: {
      instruction: 'STAR metodunu tamamla',
      sentences: [
        { text: 'S = _____', answer: 'Situation', hint: 'Durum' },
        { text: 'T = _____', answer: 'Task', hint: 'Görev' },
        { text: 'A = _____', answer: 'Action', hint: 'Eylem' },
        { text: 'R = _____', answer: 'Result', hint: 'Sonuç' }
      ]
    }
  },

  // ==================== ÜNİTE 4-5: ZOR SORULAR ====================
  'CM-M9-U4-L1': {
    lesson_id: 'CM-M9-U4-L1',
    title: 'Davranışsal Soru Nedir?',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '💼 Davranışsal Sorular',
      intro: '"Bir örnek verin" tipi sorular:',
      facts: [
        { icon: '💭', title: 'Geçmiş Davranış', text: 'Geçmişte ne yaptın?' },
        { icon: '🎯', title: 'Spesifik Örnek', text: 'Gerçek bir hikaye anlat' },
        { icon: '📋', title: 'STAR Format', text: 'Yapılandırılmış cevap' },
        { icon: '✅', title: 'Sonuç Odaklı', text: 'Ne başardın veya öğrendin?' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Davranışsal soruda ne isteniyor?',
        options: [
          { text: 'Genel görüşün', isCorrect: false, feedback: '❌ Spesifik örnek!' },
          { text: 'Gerçek bir deneyim örneği', isCorrect: true, feedback: '✅ Geçmişten somut hikaye!' },
          { text: 'Gelecek planın', isCorrect: false, feedback: '❌ Geçmiş davranış!' }
        ]
      }
    }
  },

  'CM-M9-U5-L1': {
    lesson_id: 'CM-M9-U5-L1',
    title: 'Zayıf Yön Sorusu',
    type: 'interactive',
    duration: 3,
    xp: 35,
    content: {
      title: '⚠️ "Zayıf Yönünüz?" - Strateji',
      intro: 'Bu tuzak soruya nasıl cevap verilir?',
      categories: [
        { icon: '❌', title: 'YANLIŞ', examples: '"Zayıf yönüm yok"', desc: 'Farkındalık eksik!' },
        { icon: '❌', title: 'YANLIŞ', examples: '"Sabahları zor kalkıyorum"', desc: 'İşle ilgisiz ve negatif!' },
        { icon: '✅', title: 'DOĞRU', examples: '"Mükemmeliyetçiyim ama esnek olmaya çalışıyorum"', desc: 'Zayıflık + Gelişim!' },
        { icon: '✅', title: 'DOĞRU', examples: '"Detaylara takılıyorum, büyük resmi görmeye çalışıyorum"', desc: 'Farkındalık + Çözüm!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi zayıf yön cevabı?',
        options: [
          { text: 'Hiç yok aslında', isCorrect: false, feedback: '❌ Kişisel farkındalık sıfır!' },
          { text: 'Mükemmeliyetçilik, geliştiriyorum', isCorrect: true, feedback: '✅ Farkındalık + Gelişim!' },
          { text: 'Tembelim', isCorrect: false, feedback: '❌ Aşırı negatif!' }
        ]
      }
    }
  },

  'CM-M9-U5-L5': {
    lesson_id: 'CM-M9-U5-L5',
    title: 'Senaryo: Zor Soru',
    type: 'scenario',
    duration: 5,
    xp: 55,
    scenario: {
      question: '💼 SİMÜLASYON: "Neden Sizi Seçelim?"',
      context: 'HR: "Birçok aday var. Sizi neden seçelim?"',
      options: [
        { id: 'A', text: '"Ben en iyisiyim, diğerleri kadar iyi değilllerdir"', isCorrect: false },
        { id: 'B', text: '"X yıl müşteri deneyimim, stres yönetimi becerilerim ve takım uyumum sizi sevindirecek"', isCorrect: true },
        { id: 'C', text: '"Bilmiyorum, siz karar verin"', isCorrect: false },
        { id: 'D', text: '"Bu işi çok istiyorum, lütfen alın"', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Somut değer + Özgüven + Profesyonellik!',
        wrong: '❌ Ne kibirli ne yalvarıcı - değerini göster!'
      },
      explanation: 'Güçlü cevap: Somut beceriler + Şirkete katkı + Özgüvenli ama mütevazı'
    }
  },

  // ==================== ÜNİTE 6-8: KISALTILMIŞ ====================
  'CM-M9-U6-L1': {
    lesson_id: 'CM-M9-U6-L1',
    title: 'Şirketi Araştırma',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '🔍 Şirket Araştırması = ZORUNLU',
      intro: 'Mülakattan önce bunları bil:',
      facts: [
        { icon: '📅', title: 'Tarih', text: 'Kuruluş, önemli dönüm noktaları' },
        { icon: '✈️', title: 'Filo', text: 'Uçak sayısı ve tipleri' },
        { icon: '🌐', title: 'Network', text: 'Kaç ülke, kaç destinasyon' },
        { icon: '🏆', title: 'Ödüller', text: 'Son başarılar, Skytrax' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'THY kaç ülkeye uçuyor?',
        options: [
          { text: '50-70', isCorrect: false, feedback: '❌ Daha fazla!' },
          { text: '120+', isCorrect: true, feedback: '✅ En çok ülkeye uçan havayolu!' },
          { text: '200+', isCorrect: false, feedback: '❌ Dünyada bu kadar ülke yok!' }
        ]
      }
    }
  },

  'CM-M9-U7-L1': {
    lesson_id: 'CM-M9-U7-L1',
    title: 'Mülakat Sonunda Soru Sorma',
    type: 'interactive',
    duration: 3,
    xp: 30,
    content: {
      title: '❓ "Soru Sormak İster misiniz?"',
      intro: 'Bu fırsatı kaçırma!',
      categories: [
        { icon: '✅', title: 'SOR', examples: '"Eğitim süreci nasıl?"', desc: 'İlgi gösterir' },
        { icon: '✅', title: 'SOR', examples: '"Takım kültürü nasıl?"', desc: 'Uyum arar' },
        { icon: '❌', title: 'SORMA', examples: '"Maaş ne kadar?"', desc: 'Henüz erken!' },
        { icon: '❌', title: 'SORMA', examples: '"Tatiller ne zaman?"', desc: 'Motivasyonsuz!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi soru?',
        options: [
          { text: 'Maaş artışı ne sıklıkla?', isCorrect: false, feedback: '❌ Para odaklı!' },
          { text: 'Eğitim ve gelişim fırsatları?', isCorrect: true, feedback: '✅ Gelişim odaklı!' },
          { text: 'Sorum yok', isCorrect: false, feedback: '❌ İlgisiz görünürsün!' }
        ]
      }
    }
  },

  // ==================== EKSİK DERSLER ====================
  // ÜNİTE 4 - EKSİKLER
  'CM-M9-U4-L2': {
    lesson_id: 'CM-M9-U4-L2',
    title: 'Güçlü Yönler',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '💪 Güçlü Yönleriniz',
      intro: 'Havacılıkla ilgili güçlü yönlerinizi vurgulayın',
      facts: [
        { icon: '✅', title: 'İletişim', text: '"Farklı insanlarla iyi anlaşırım"' },
        { icon: '✅', title: 'Esneklik', text: '"Değişime hızlı uyum sağlarım"' },
        { icon: '✅', title: 'Takım', text: '"Takım çalışmasını severim"' },
        { icon: '✅', title: 'Stres', text: '"Baskı altında sakin kalırım"' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi güçlü yön cevabı?',
        options: [
          { text: '"Mükemmeliyetçiyim"', isCorrect: false, feedback: '❌ Klişe!' },
          { text: '"Zor yolcularda bile sakin kalabilirim, örneğin..."', isCorrect: true, feedback: '✅ Spesifik ve örnekli!' },
          { text: '"Her şeyi yapabilirim"', isCorrect: false, feedback: '❌ İnandırıcı değil!' }
        ]
      }
    }
  },

  'CM-M9-U4-L3': {
    lesson_id: 'CM-M9-U4-L3',
    title: 'Zayıf Yönler',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🔧 Zayıf Yönleriniz',
      intro: 'Gerçek ama geliştirdiğiniz bir zayıflık söyleyin',
      categories: [
        { icon: '✅', title: 'Doğru', examples: '"Bazen çok detaycıyım"', desc: 'Ve nasıl geliştirdiğini ekle' },
        { icon: '✅', title: 'Doğru', examples: '"Hayır demekte zorlanırdım"', desc: '"Artık öncelik koyuyorum"' },
        { icon: '❌', title: 'Yanlış', examples: '"Zayıf yönüm yok"', desc: 'Farkındalık eksik!' },
        { icon: '❌', title: 'Yanlış', examples: '"Tembelim"', desc: 'Kendini baltalama!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'En iyi zayıf yön cevabı?',
        options: [
          { text: '"Yok"', isCorrect: false, feedback: '❌ Farkındalık eksik!' },
          { text: '"Eskiden X\'te zorlanırdım, ama şimdi Y yapıyorum"', isCorrect: true, feedback: '✅ Gelişim odaklı!' },
          { text: '"Çok fazla zayıflığım var"', isCorrect: false, feedback: '❌ Özgüven eksik!' }
        ]
      }
    }
  },

  'CM-M9-U4-L4': {
    lesson_id: 'CM-M9-U4-L4',
    title: 'Senaryo: Güçlü/Zayıf Soru',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: '💪🔧 SENARYO: Güçlü ve Zayıf Yön',
      context: 'Jüri soruyor: "En büyük zayıflığınız nedir?" Ne dersiniz?',
      options: [
        { id: 'A', text: '"Eskiden delegasyonda zorlanırdım, ama artık takım arkadaşlarıma güvenmeyi öğrendim"', isCorrect: true },
        { id: 'B', text: '"Zayıflığım yok, her şeyi yapabilirim"', isCorrect: false },
        { id: 'C', text: '"Çok tembelim"', isCorrect: false },
        { id: 'D', text: '"Bilmiyorum"', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Mükemmel! Gerçek zayıflık + gelişim = özfarkındalık!',
        wrong: '❌ Dürüst ol ama kendini baltalama. Gelişim göster.'
      },
      explanation: 'Her zayıflık sorusunda "Eskiden... ama şimdi..." formülü kullan.'
    }
  },

  'CM-M9-U4-L5': {
    lesson_id: 'CM-M9-U4-L5',
    title: '⚡ Güçlü/Zayıf Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Zayıf yön sorusunda ne söyleme?', options: ['Yok', 'Geliştiriyorum', 'Tembelim', 'İkisi de'], correct: 2 },
        { q: 'Güçlü yön nasıl anlatılır?', options: ['Genel', 'Örnekle', 'Abartarak', 'Kısa'], correct: 1 },
        { q: '"Mükemmeliyetçiyim" iyi mi?', options: ['Evet', 'Hayır, klişe', 'Belki', 'Her zaman'], correct: 1 },
        { q: 'Zayıflık formülü?', options: ['Yok de', 'Eskiden-Şimdi', 'Abartı', 'Sessiz kal'], correct: 1 },
        { q: 'Havacılıkla ilgili güçlü yön?', options: ['Yemek sevmek', 'Stres yönetimi', 'Uyku', 'Yalnızlık'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 5 - EKSİKLER
  'CM-M9-U5-L2': {
    lesson_id: 'CM-M9-U5-L2',
    title: 'Kariyer Planı',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '🎯 5 Yıllık Kariyer Planı',
      intro: '"5 yıl sonra nerede olmak istersiniz?"',
      facts: [
        { icon: '✅', title: 'Doğru', text: '"Deneyimli bir kabin memuru olarak..."' },
        { icon: '✅', title: 'Doğru', text: '"Purser pozisyonuna doğru ilerlemek"' },
        { icon: '❌', title: 'Yanlış', text: '"Pilot olmak istiyorum"', desc: 'Farklı kariyer!' },
        { icon: '❌', title: 'Yanlış', text: '"Başka şirkete geçmek"', desc: 'Sadakat sorgusu!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: '5 yıl sonra hedef?',
        options: [
          { text: '"Pilot olmak istiyorum"', isCorrect: false, feedback: '❌ Farklı kariyer yolu!' },
          { text: '"Deneyimli kabin memuru, belki purser"', isCorrect: true, feedback: '✅ Gerçekçi ve şirkette ilerleme!' },
          { text: '"Bilmiyorum"', isCorrect: false, feedback: '❌ Plansız görünür!' }
        ]
      }
    }
  },

  'CM-M9-U5-L3': {
    lesson_id: 'CM-M9-U5-L3',
    title: 'Stres Soruları',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '😰 Stres ve Provokasyon Soruları',
      intro: 'Jüri sizi test edebilir - sakin kalın!',
      facts: [
        { icon: '⚠️', title: '"Neden sizi alalım?"', text: 'Değerinizi özgüvenle anlat' },
        { icon: '⚠️', title: '"Çok genç/tecrübesizsiniz"', text: 'Öğrenme isteği ve enerji vurgula' },
        { icon: '⚠️', title: '"Bu iş size göre değil"', text: 'Motivasyonunu göster, savunmaya geçme' },
        { icon: '⚠️', title: '"Başka şirketlere de başvurdunuz mu?"', text: 'Dürüst ol ama bu şirketi ön plana koy' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: '"Bu iş size göre değil" denilse?',
        options: [
          { text: 'Kızar, tartışırım', isCorrect: false, feedback: '❌ Savunmacı!' },
          { text: 'Sakin kalır, nedenini sorar, motivasyonumu gösteririm', isCorrect: true, feedback: '✅ Profesyonel tepki!' },
          { text: 'Susar, küserim', isCorrect: false, feedback: '❌ Zayıf görünür!' }
        ]
      }
    }
  },

  'CM-M9-U5-L4': {
    lesson_id: 'CM-M9-U5-L4',
    title: 'Senaryo: Provokasyon',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: '😤 SENARYO: Provokasyon',
      context: 'Jüri diyor ki: "Sizin yaşınızda biri bu işi yapamaz. Çok genç ve tecrübesizsiniz."',
      options: [
        { id: 'A', text: 'Sakin kalır, enerjimi ve öğrenme isteğimi vurgularım', isCorrect: true },
        { id: 'B', text: 'Kızarım, yaş ayrımcılığı derim', isCorrect: false },
        { id: 'C', text: 'Susar, kabul ederim', isCorrect: false },
        { id: 'D', text: 'Mülakattan çıkarım', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Harika! Stres testi geçildi! Sakin + pozitif = profesyonel!',
        wrong: '❌ Bu bir stres testi. Tepkinizi ölçüyorlar. Sakin kalın!'
      },
      explanation: 'Jüri gerçekten öyle düşünmüyor, sadece tepkinizi test ediyor.'
    }
  },

  'CM-M9-U5-L6': {
    lesson_id: 'CM-M9-U5-L6',
    title: '🎮 Zor Soru Eşleştir',
    type: 'matching',
    duration: 4,
    xp: 40,
    matching: {
      instruction: 'Soruları doğru cevap stratejisiyle eşleştir',
      pairs: [
        { id: 1, left: '"Neden sizi alalım?"', right: 'Değerini özgüvenle anlat' },
        { id: 2, left: '"Zayıf yönünüz?"', right: 'Eskiden-Şimdi formülü' },
        { id: 3, left: '"5 yıl sonra?"', right: 'Şirkette ilerleme planı' },
        { id: 4, left: '"Bu iş size göre değil"', right: 'Sakin kal, motivasyon göster' },
        { id: 5, left: '"Güçlü yönünüz?"', right: 'Havacılıkla ilgili örnekle' }
      ]
    }
  },

  // ÜNİTE 6 - EKSİKLER
  'CM-M9-U6-L2': {
    lesson_id: 'CM-M9-U6-L2',
    title: 'İngilizce Mülakat',
    type: 'interactive',
    duration: 5,
    xp: 30,
    content: {
      title: '🇬🇧 İngilizce Mülakat',
      intro: 'Havacılıkta İngilizce şart!',
      facts: [
        { icon: '💬', title: 'Akıcılık', text: 'Mükemmel değil, anlaşılır ol' },
        { icon: '📢', title: 'Telaffuz', text: 'Net ve anlaşılır' },
        { icon: '🎯', title: 'Basit Tut', text: 'Karmaşık cümlelerden kaçın' },
        { icon: '😊', title: 'Özgüven', text: 'Hata yapsan da devam et' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'İngilizce mülakatında en önemli?',
        options: [
          { text: 'Mükemmel gramer', isCorrect: false, feedback: '❌ Anlaşılırlık daha önemli!' },
          { text: 'Akıcı ve anlaşılır olmak', isCorrect: true, feedback: '✅ İletişim kurabilmek şart!' },
          { text: 'Uzun cümleler', isCorrect: false, feedback: '❌ Basit ve net ol!' }
        ]
      }
    }
  },

  'CM-M9-U6-L3': {
    lesson_id: 'CM-M9-U6-L3',
    title: 'Senaryo: İngilizce Zor An',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: '🇬🇧 SENARYO: İngilizce Takılma',
      context: 'İngilizce soruda bir kelimeyi unuttunuz, takıldınız. Ne yaparsınız?',
      options: [
        { id: 'A', text: 'Derin nefes alır, farklı kelimelerle anlatmaya çalışırım', isCorrect: true },
        { id: 'B', text: 'Panik yapar susar', isCorrect: false },
        { id: 'C', text: 'Türkçe devam ederim', isCorrect: false },
        { id: 'D', text: '"I don\'t know" der geçerim', isCorrect: false }
      ],
      feedback: {
        correct: '🎯 Doğru! Paraphrase (farklı kelimelerle anlatma) gösterir!',
        wrong: '❌ Takılmak normal, önemli olan devam etmek.'
      },
      explanation: 'Kelime bulamıyorsanız açıklama yapın: "I mean..." "In other words..."'
    }
  },

  'CM-M9-U6-L4': {
    lesson_id: 'CM-M9-U6-L4',
    title: '⚡ İngilizce Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'İngilizce mülakatında en önemli?', options: ['Gramer', 'Akıcılık', 'Uzun cümle', 'Aksent'], correct: 1 },
        { q: 'Kelime unuttunuz?', options: ['Sus', 'Türkçe söyle', 'Paraphrase', 'Geç'], correct: 2 },
        { q: '"Tell me about yourself" cevabı?', options: ['Çocukluk', 'Şimdiki durum', 'Aile', 'Hastalık'], correct: 1 },
        { q: '"Why cabin crew?"', options: ['Para', 'Travel + Service', 'Uniform', 'Kolay'], correct: 1 },
        { q: 'Anlaşılmadığınızda?', options: ['Daha yüksek sesle', 'Tekrar açıkla', 'Kız', 'Geç'], correct: 1 }
      ]
    }
  },

  // ÜNİTE 7 - EKSİKLER
  'CM-M9-U7-L2': {
    lesson_id: 'CM-M9-U7-L2',
    title: 'Sorulacak Sorular',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '❓ Jüriye Soru Sorun',
      intro: '"Sorunuz var mı?" sorusuna hazır olun!',
      categories: [
        { icon: '✅', title: 'Sor', examples: '"Eğitim süreci nasıl?"', desc: 'İlgi gösterir' },
        { icon: '✅', title: 'Sor', examples: '"Kariyer gelişimi nasıl?"', desc: 'Uzun vadeli düşünce' },
        { icon: '❌', title: 'Sorma', examples: '"Maaş ne kadar?"', desc: 'Henüz erken!' },
        { icon: '❌', title: 'Sorma', examples: '"Sorum yok"', desc: 'İlgisiz görünür!' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakat sonunda en iyi soru?',
        options: [
          { text: '"Maaş artışları ne sıklıkla?"', isCorrect: false, feedback: '❌ Para odaklı!' },
          { text: '"Eğitim süreci ve ilk günler nasıl?"', isCorrect: true, feedback: '✅ İş odaklı ve meraklı!' },
          { text: '"Sorum yok"', isCorrect: false, feedback: '❌ İlgisiz!' }
        ]
      }
    }
  },

  'CM-M9-U7-L3': {
    lesson_id: 'CM-M9-U7-L3',
    title: 'Mülakat Sonrası',
    type: 'interactive',
    duration: 5,
    xp: 25,
    content: {
      title: '📧 Mülakat Sonrası',
      intro: 'İyi izlenim bırakın!',
      steps: [
        { level: 1, title: '🤝 Teşekkür', desc: 'Çıkarken jüriye teşekkür edin' },
        { level: 2, title: '😊 Gülümse', desc: 'Son izlenim de önemli' },
        { level: 3, title: '📝 Not Al', desc: 'Deneyiminizi yazın, analiz edin' },
        { level: 4, title: '⏳ Bekle', desc: 'Sonucu sabırla bekleyin' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'Mülakat sonrası ne yapmalı?',
        options: [
          { text: 'Hemen sosyal medyada paylaş', isCorrect: false, feedback: '❌ Gizlilik önemli!' },
          { text: 'Teşekkür et, not al, analiz yap', isCorrect: true, feedback: '✅ Profesyonel yaklaşım!' },
          { text: 'Hemen diğer şirketlere başvur', isCorrect: false, feedback: '❌ Sonucu bekle!' }
        ]
      }
    }
  },

  // ÜNİTE 8 - EKSİKLER
  'CM-M9-U8-L1': {
    lesson_id: 'CM-M9-U8-L1',
    title: 'Final Tekrarı',
    type: 'interactive',
    duration: 5,
    xp: 30,
    content: {
      title: '📚 Birebir Mülakat Özeti',
      intro: 'Tüm önemli noktaların tekrarı',
      facts: [
        { icon: '👤', title: 'Kendin Tanıt', text: 'Şimdiki durum → İlgili geçmiş → Gelecek hedef' },
        { icon: '❓', title: 'Neden Kabin?', text: 'Hizmet + Seyahat + Takım (Para DEĞİL)' },
        { icon: '⭐', title: 'STAR', text: 'Situation-Task-Action-Result' },
        { icon: '💪', title: 'Güçlü/Zayıf', text: 'Örnekle + Gelişim odaklı' }
      ],
      challenge: {
        type: 'multipleChoice',
        question: 'STAR metodunda T ne demek?',
        options: [
          { text: 'Time', isCorrect: false, feedback: '❌ T = Task!' },
          { text: 'Task', isCorrect: true, feedback: '✅ Göreviniz ne idi?' },
          { text: 'Team', isCorrect: false, feedback: '❌ T = Task!' }
        ]
      }
    }
  },

  'CM-M9-U8-L2': {
    lesson_id: 'CM-M9-U8-L2',
    title: '🎮 Final Doğru/Yanlış',
    type: 'truefalse',
    duration: 5,
    xp: 40,
    truefalse: {
      statements: [
        { statement: '"Neden kabin memuru?" sorusuna "seyahat etmek için" iyi cevaptır.', isTrue: false, explanation: '❌ Sadece seyahat değil, HİZMET de vurgula!' },
        { statement: 'STAR metodunda önce durum açıklanır.', isTrue: true, explanation: '✅ S = Situation!' },
        { statement: '"Zayıf yönüm yok" iyi bir cevaptır.', isTrue: false, explanation: '❌ Farkındalık eksik görünür!' },
        { statement: 'Mülakat sonunda soru sormak önemlidir.', isTrue: true, explanation: '✅ İlgi ve merak gösterir!' },
        { statement: 'Provokasyona kızmak normaldir.', isTrue: false, explanation: '❌ Sakin kalın, test ediyorlar!' }
      ]
    }
  },

  'CM-M9-U8-L3': {
    lesson_id: 'CM-M9-U8-L3',
    title: '⚡ Final Yarışı',
    type: 'timerace',
    duration: 5,
    xp: 50,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'STAR\'da S?', options: ['Story', 'Situation', 'Success', 'Simple'], correct: 1 },
        { q: 'Kendin tanıtırken başla?', options: ['Çocukluk', 'Şimdiki durum', 'Aile', 'Okul'], correct: 1 },
        { q: 'Zayıf yön formülü?', options: ['Yok de', 'Eskiden-Şimdi', 'Çok var', 'Geç'], correct: 1 },
        { q: '5 yıl sonra hedef?', options: ['Pilot', 'Deneyimli ekip', 'Ayrılmak', 'Müdür'], correct: 1 },
        { q: 'Mülakat sonunda soru?', options: ['Maaş', 'Eğitim süreci', 'Tatil', 'Sorma'], correct: 1 },
        { q: 'Provokasyona tepki?', options: ['Kız', 'Sakin kal', 'Sus', 'Çık'], correct: 1 }
      ]
    }
  },

  // ==================== ÜNİTE 8: FİNAL ====================
  'CM-M9-U8-L4': {
    lesson_id: 'CM-M9-U8-L4',
    title: '🎓 Birebir Mülakat Final Quiz',
    type: 'exam',
    duration: 12,
    xp: 120,
    exam: {
      questions: [
        { q: 'Neden kabin memuru - Yanlış?', options: ['Hizmet', 'Gezi', 'Takım', 'Gelişim'], correct: 1 },
        { q: 'Kendini tanıtırken başlangıç?', options: ['Çocukluk', 'Şimdiki durum', 'Doğum yeri', 'Aile'], correct: 1 },
        { q: 'STAR\'da S?', options: ['Success', 'Situation', 'Story', 'Step'], correct: 1 },
        { q: 'STAR\'da R?', options: ['Ready', 'Run', 'Result', 'Real'], correct: 2 },
        { q: 'Zayıf yön cevabı?', options: ['Yok', 'Geliştiriyorum', 'Tembelim', 'Çok fazla'], correct: 1 },
        { q: '5 yıl hedefi?', options: ['Pilot', 'Deneyimli ekip', 'Ayrılmak', 'Yönetici'], correct: 1 },
        { q: 'THY kaç ülkeye uçuyor?', options: ['50', '80', '120+', '200'], correct: 2 },
        { q: 'Mülakat sonunda soru?', options: ['Maaş', 'Eğitim süreci', 'Tatil', 'Sorma'], correct: 1 },
        { q: 'Davranışsal soruda ne istenir?', options: ['Görüş', 'Plan', 'Örnek', 'Tahmin'], correct: 2 },
        { q: 'Provokasyona cevap?', options: ['Kız', 'Motivasyon göster', 'Pes et', 'Soru sor'], correct: 1 }
      ]
    }
  }
};

export default cabinCrewContentsM9Interactive;
